import { FC, useState } from 'react';

import { Form, Select } from 'antd';
import { Trans } from 'react-i18next';
import { Icon, Input, Label, TextArea } from 'ui';

import { OfferType } from 'types/promoters/promoterTypes';

import s from './EventOfferType.module.scss';

const defaultOfferTypes = [
  {
    value: OfferType.fixedPriceOnSpecificTicketTypes,
    label: 'Fixed prices on specific ticket types',
  },
  { value: OfferType.fixedPriceOnAllTicketTypes, label: 'Fixed price on each ticket type' },
  {
    value: OfferType.greaterOrEqualToNumberOfTickets,
    label: 'Greater or equal than number of tickets',
  },
  { value: OfferType.perMultipleNumberOfTickets, label: 'Per multiple number of tickets' },
  { value: OfferType.fixedDiscount, label: 'Fixed percentage discount' },
  { value: OfferType.perDifferentShowNames, label: 'Per different show' },
  { value: OfferType.perDifferentEvents, label: 'Per different event' },
];

const defaultEnableState = [
  { label: 'Enabled', value: true },
  { label: 'Disabled', value: false },
];

interface EventOfferTypeProps {
  setOfferType: (state: OfferType) => void;
  offerType: string;
}

const EventOfferType: FC<EventOfferTypeProps> = (props) => {
  const { offerType, setOfferType } = props;
  const [enableState, setEnableState] = useState(defaultEnableState[0].value);

  return (
    <div className={s.entireWrapper}>
      <div className={s.wrapper}>
        <div className={s.header}>
          <div style={{ width: '100%' }}>
            <Label>Offer Type</Label>
            <Form.Item name="offerType">
              <Select
                style={{ width: '100%', height: 40 }}
                onChange={(value) => setOfferType(value as OfferType)}
                options={defaultOfferTypes?.map((item) => ({
                  label: item.label,
                  value: item.value,
                }))}
                value={offerType}
                defaultValue={OfferType.fixedPriceOnSpecificTicketTypes}
              />
            </Form.Item>
          </div>
          <div style={{ width: '100%' }}>
            <Label>Enabled?</Label>
            <Form.Item name="active" initialValue={false}>
              <Select
                style={{ width: '100%', height: 40 }}
                onChange={(value) => setEnableState(value)}
                options={defaultEnableState?.map((item) => ({
                  label: item.label,
                  value: item.value,
                }))}
                value={enableState}
              />
            </Form.Item>
          </div>
        </div>
        <div className={s.name}>
          <Label required>Name of offer</Label>
          <Form.Item
            name="name"
            validateFirst
            rules={[
              { required: true, message: 'Name is required' },
              { min: 5, message: 'Name must be at least 5 characters' },
            ]}>
            <Input
              name="name"
              showCount
              minLength={5}
              maxLength={100}
              size="middle"
              placeholder="Enter name"></Input>
          </Form.Item>
        </div>
        <div className={s.description}>
          <Label required>Description</Label>
          <Form.Item
            name="description"
            validateFirst
            rules={[
              { required: true, message: 'Description is required' },
              { min: 5, message: 'Description must be at least 5 characters' },
            ]}>
            <TextArea
              name="description"
              size="middle"
              placeholder="Enter description of your offer"></TextArea>
          </Form.Item>
        </div>
      </div>
      <div className={s.hintWrapper}>
        <div className={s.hint}>
          <div>
            <Icon name="warning" />
          </div>
          <Trans i18nKey={offerType} components={{ b: <b /> }} />
        </div>
      </div>
    </div>
  );
};

export default EventOfferType;
